export const shared = {
	name: 'Arematics',
	client_id: 'arematics-courses',
	realm_name: 'arematics'
};
